import React from 'react'
import { getRegexFromTerm } from 'utils/search'
import { Checkbox, Input } from 'components/UIElements'
import 'styles/d3/autocompleteSearch.scss'

// item: { key: 1, text: 'name' }

class AutocompleteSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = { searchTerm: '', isFocused: false }
    this.noMatches = true
  }

  componentDidMount() {
    this.blurListener = e => {
      if (!this.refs.thisComponent.contains(e.target)) {
        this.setState({ isFocused: false })
      }
    }
    document.addEventListener('mouseup', this.blurListener)
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.blurListener)
  }

  onFocus = () => {
    if (!this.state.isFocused) this.setState({ isFocused: true })
  }

  renderList = () => {
    const regex = getRegexFromTerm(this.state.searchTerm)
    this.noMatches = true
    return this.props.list.map((item, idx) => {
      const isMatch = item.text.match(regex)
      const showItem = this.state.isFocused && (this.state.searchTerm === '' || isMatch)
      if (isMatch && this.noMatches) this.noMatches = false
      const className = 'list-item' + (showItem ? '' : ' hidden')
      return (
        <li onMouseDown={this.onMouseDown} className={className} key={item.key + '' + idx}>
          <Checkbox
            label={item.text}
            checked={item.key in this.props.checked}
            onClick={() => this.props.toggleItem(item.key)}
          />
        </li>
      )
    })
  }

  render() {
    const { className, list, value, onChange, placeholder, renderTopItem } = this.props
    return (
      <div ref='thisComponent' className={`autocomplete-search${className ? ' ' + className : ''}`}>
        <Input
          onFocus={this.onFocus}
          placeholder={placeholder}
          value={this.state.searchTerm}
          onChange={value => this.setState({ searchTerm: value })}
        />
        <i className='fa fa-search' />
        <ul className={'autocomplete-list' + (this.state.isFocused ? '' : ' hidden')}>
          {renderTopItem && this.state.searchTerm !== '' && renderTopItem(this.state.searchTerm)}
          {this.renderList()}
          {this.noMatches && !renderTopItem && <li className='list-item'>No Matching Results</li>}
        </ul>
      </div>
    )
  }
}

export default AutocompleteSearch



// WEBPACK FOOTER //
// ./src/components/AutocompleteSearch.js